import { useLocation } from 'react-router'

const styles = {
  top: 0,
  left: 0,
  backgroundColor: 'var(--brand)',
  color: '#fff',
  fontWeight: 500,
  padding: '2px 10px 2px 7px',
  borderBottomRightRadius: '5px',
  marginBottom: 0,
  fontSize: 20,
  zIndex: 9999,
}

const Draft = (): JSX.Element | null => {
  const { search } = useLocation()
  if (search === '?draft') {
    return <p style={{ ...styles, position: 'fixed' }}>Viewing a draft</p>
  }
  return null
}

export default Draft
